module.exports = __webpack_public_path__ + "img/ylb-en2.b7943790.png";